<template>
  <aside>
    <h1>{{ $t('gift-shop.key001') }}</h1>
    <nav>
      <ul>
        <li>
          <router-link :to="`/${currentLanguage}/gift-shop/giftItem`" active-class="active">{{ $t('gift-shop.key002') }} </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'NavAside',
  computed: {},
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss"></style>
